import React, { FunctionComponent } from 'react'
import { Header, Text } from '@lightspeed/design-system-react'
import { VendImage } from '@vend/react-utilities'
import { T } from '@transifex/react'

export const NoSales: FunctionComponent = () => (
  <div className="wr-retrieve-sale-empty vd-pa5">
    <VendImage
      relativeImagePath="sell/empty-basket-v2.svg"
      relativeDarkImagePath="sell/empty-basket-v2-dark.svg"
      className="wr-retrieve-sale-empty-image vd-mb5"
    />
    <Header level="2" type="sub-heading" className="vd-text-label">
      <T
        _str="You don’t have any parked sales."
        _context="Message when no parked sales are found"
      />
    </Header>
    <Text tag="p" className="vd-mt3">
      <T
        _str="Parked sales allow you to put products on hold while you serve other
      customers."
        _context="Message when no parked sales are found"
      />
    </Text>
  </div>
)
